var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scrolltop d-print-none",attrs:{"id":"kt_scrolltop"}},[_c('span',{staticClass:"fa fa-fw fa-angle-up fa-2x text-white"})])
}]

export { render, staticRenderFns }